// FormAPI
require('./FormAPI')

require('./Dropzone/dropzoneInit')

require('./geolocation')
require('./Ad/adPublishController')
require('./Homepage/homepage')
require('./Homepage/howitworks')
require('./starRating')

require('./Homepage/feed')

require('./autoreply')

require('./sendMessage')

require('./Profile/userAddress')

require('./Profile/sellerSearch')

require('./importCsv/importCsv')

/* Datatables */
require('./Datatables/Datatables')

require('./tinymceInit')
